import * as React from "react";
function SvgAgConsulta(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9 3.692a.692.692 0 00-1.385 0v1.154H5.203C4 4.846 3 5.804 3 7.016V18.83C3 20.042 4 21 5.203 21h3.89a.692.692 0 100-1.385h-3.89a.803.803 0 01-.818-.786v-7.983h15.23V13.1a.692.692 0 101.385 0V7.017c0-1.213-1-2.17-2.203-2.17h-2.412V3.691a.692.692 0 10-1.385 0v1.154H9V3.692zM5.203 6.231h2.412v.23a.692.692 0 001.385 0v-.23h6v.23a.692.692 0 001.385 0v-.23h2.412c.466 0 .818.366.818.786v2.445H4.385V7.017c0-.42.352-.786.818-.786zM12.063 21C11.2 21 11 20.817 11 19.94v-4.243c0-.877.2-1.06 1.063-1.06h4.25c1.361 0 1.562.183 1.562 1.59v3.712c0 .878-.2 1.061-1.063 1.061h-4.75zm8.033-.9a.606.606 0 00.477.034.624.624 0 00.362-.32.65.65 0 00.065-.283v-3.425c0-.17-.065-.33-.183-.45a.614.614 0 00-.722-.119l-1.422.724a.317.317 0 00-.168.23l-.005.001V19.144l.005.002a.317.317 0 00.168.23l1.423.724z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgAgConsulta);
export default ForwardRef;
